export const exercise = [
  {no: 1, type: "느리게 걷기", mets: 2},
  {no: 2, type: "걷기", mets: 3},
  {no: 3, type: "계단오르기", mets: 11},
  {no: 4, type: "야구", mets: 5},
  {no: 5, type: "웨이트트레이닝", mets: 3},
  {no: 6, type: "볼링", mets: 3},
  {no: 7, type: "맨손체조", mets: 3.5},
  {no: 8, type: "골프", mets: 5},
  {no: 9, type: "빠른 보행", mets: 3.8},
  {no: 10, type: "속보", mets: 4},
  {no: 11, type: "탁구", mets: 4},
  {no: 12, type: "태극권", mets: 4},
  {no: 13, type: "아쿠아빅", mets: 4},
  {no: 14, type: "조깅", mets: 7.3},
  {no: 15, type: "테니스", mets: 5},
  {no: 16, type: "축구", mets: 7},
  {no: 17, type: "에어로빅", mets: 6},
  {no: 18, type: "수영", mets: 9.8},
  {no: 19, type: "배드민턴", mets: 6},
  {no: 20, type: "미용체조", mets: 6},
  {no: 21, type: "등산", mets: 7.5},
  {no: 22, type: "사이클", mets: 8},
  {no: 23, type: "태권도", mets: 10},
  {no: 24, type: "유도", mets: 10},
  {no: 25, type: "줄넘기", mets: 10},
  {no: 26, type: "스트레칭", mets: 2.5},
  {no: 27, type: "요가", mets: 2.5},
  {no: 28, type: "가벼운 댄스", mets: 3},
  {no: 29, type: "격렬한 댄스", mets: 7},
  {no: 30, type: "필라테스", mets: 3.4},
  {no: 31, type: "스쿼시", mets: 7.5},
  {no: 32, type: "당구", mets: 2.4},
  {no: 33, type: "카누", mets: 2.5},
  {no: 34, type: "크로켓", mets: 3},
  {no: 35, type: "가볍게 자전거타기" , mets: 3.5},
  {no: 36, type: "중간속도 자전거타기", mets: 5.9},
  {no: 37, type: "언덕오르기", mets: 7},
  {no: 38, type: "승마", mets: 2.4},
  {no: 39, type: "수상스키", mets: 6.8},
  {no: 40, type: "스키", mets: 6.4}
];